









import { Prop, Component, Vue, Watch, PropSync } from "vue-property-decorator";
import SelectOption from "@/common/ui/presenters/select-option";

/**
 * 会社の事業形態のセレクトボックス
 */
@Component({})
export default class SelectCompanyType extends Vue {
  @Prop({ type: String }) value?: string;
  @Prop({ type: String }) size?: string;
  @Prop({ type: String, default: "全ての事業形態" }) defaultOptionText!: string;

  @PropSync("text", { type: String, default: "" }) textSync!: string;

  companyType: string = "";

  get options(): SelectOption[] {
    return [
      { text: this.defaultOptionText, value: "" },
      { text: "法人", value: "1" },
      { text: "個人", value: "2" },
      { text: "エンドユーザー", value: "3" }
    ];
  }

  @Watch("value", { immediate: true })
  onValueChanged(companyType: string) {
    this.companyType = companyType;
  }

  input() {
    this.$emit("input", this.companyType);
    // textを得るためにsync使ってるけど、Vuexとかで取り直した方がいいかも
    this.textSync = this.getSelectedText();
  }

  private getSelectedText(): string {
    const option = this.options.find(o => o.value === this.companyType);
    return option ? option.text : "";
  }
}
